<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'informes'}">{{$t("informes")}}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{$t("ventaDeProductosPorRangoDeMesas")}}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="listBusiness">{{$t("negocio")}}</label>

                <el-select class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="$t('seleccionaNegocio')"
                  @change="getTpv(),idsTPV=[]">

                  <el-option v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.id">
                  </el-option>
                </el-select>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label for="listTPV">{{$t("TPV")}}</label>

                <div class="row">
                  <div class="col-12">
                    <el-select class="select-default"
                      size="large"
                      v-model="idTpv"
                      filterable
                      @change="changeTPV()"
                      :placeholder="$t('seleccionaNegocio')">

                      <el-option v-for="tpv in listTpv"
                        class="select-primary"
                        :value="tpv.id"
                        :label="tpv.nameShow"
                        :key="tpv.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label for="listRangos">{{$t("rangoDeMesas")}}</label>

                <div class="row">
                  <div class="col-12">
                    <el-select class="select-default"
                      size="large"
                      v-model="idRangoMesa"
                      filterable
                      @change="changeRango()"
                      :placeholder="$t('seleccionaNegocio')">

                      <el-option v-for="rango in listRangoMesas"
                        class="select-primary"
                        :value="rango.id"
                        :label="rango.nameShow"
                        :key="rango.id">
                      </el-option>
                    </el-select>
                  </div>
                </div>

              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{$t("fechaInicio")}}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  format="dd-MM-yyyy"
                  :title="$t('fechaInicio')"
                  :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                  input-class="form-control"
                  v-model="datefrom">
                </datetime>
              </div>
            </div>

            <div class="col-md-2">
              <div class="form-group">
                <label>{{$t("fechaFin")}}</label>
                <datetime
                  value-zone="Europe/Madrid"
                  :auto="true"
                  class="theme-numier"
                  :title="$t('fechaFin')"
                  format="dd-MM-yyyy"
                  :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                  input-class="form-control"
                  v-model="dateto">
                </datetime>
              </div>
            </div>

            <div class="col-md-1">
              <label>&nbsp;</label>
              <div class="form-group">
                <button class="btn btn-primary" @click="emitirConsulta()">
                  <img src="static/img/sync.gif" alt="" v-if="loadingConsulta" width="15">
                    {{$t("consultar")}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Hasta aqui-->
      <template v-if="!permiso">
          <div class="alert alert-danger m-3" style="width: 100%" role="alert">
              Lo sentimos. Este negocio no cuenta con este módulo activado.
          </div>
      </template>
      <div class="col-md-8" v-else-if="respuesta">
        <template v-if="list.length > 0">
          <div class="row justify-content-between div-export">

            <div class="col-md-2 col-xs-12 text-right">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a :href="urlExportPDF">
                    <el-dropdown-item class="text-danger">
                      <strong
                        ><i class="fa fa-file-pdf"></i>
                        {{ $t("exportarPdf") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
              <div class="col-md-5" v-if="hayMenus">
                <label style="font-size:0.8em">
                  <strong>{{ $t('excluirPrecioMedioMenu') }}</strong>
                </label>

                <el-switch 
                  v-model="excluirMenu"
                  active-color="#13ce66"
                  inactive-color="#bcbcbc"
                >
                </el-switch>
              </div>
              <div class="col-md-4">
                <label style="font-size:0.8em">
                  <strong>{{ $t("ocultarSaldo") }}</strong>
                </label>

                <el-switch 
                  v-model="checkValue"
                  active-color="#13ce66"
                  inactive-color="#bcbcbc"
                  @change="emitirConsulta()"
                >
                </el-switch>
              </div>

          </div>
          
          <div class="table-responsive">
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr style="cursor: pointer;">
                  <th
                    v-if="ordenacionProductos === 0"
                    @click="sortedArrayNameASC('name')"
                  >
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("producto") }}
                  </th>
                  <th v-else @click="sortedArrayNameDESC('name')">
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("producto") }}
                  </th>
                  <th
                    v-if="ordenarBarcode === 0"
                    @click="sortedArrayBarcodeASC('barcode')"
                  >
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("codigoBarra") }}
                  </th>
                  <th v-else @click="sortedArrayBarcodeDESC('barcode')">
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("codigoBarra") }}
                  </th>
                  <th
                    v-if="ordenarCantidad === 0"
                    @click="sortedArrayCantidadASC('cantidad')"
                  >
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("cantidad") }}
                  </th>
                  <th v-else @click="sortedArrayCantidadDESC('cantidad')">
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("cantidad") }}
                  </th>

                  <template v-if="hayMenus">
                    <th
                      v-if="ordenarCantidadMenu === 0"
                      @click="sortedArrayCantidadMenuASC('cantidadMenu')" v-tooltip.top-center="'Cantidad en menús'"
                    >
                      <i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("cEnMenus") }}
                    </th>
                    <th v-else @click="sortedArrayCantidadMenuDESC('cantidadMenu')"  v-tooltip.top-center="'Cantidad en menús'">
                      <i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("cEnMenus") }}
                    </th>
                    <th
                      v-if="ordenarCantidadMenuDiferencia === 0"
                      @click="sortedArrayCantidadMenuDiferenciaASC('cantidadDiferencia')"  v-tooltip.top-center="'Cantidad fuera de menús'"
                    >
                      <i style="color: white" class="fa fa-angle-up"></i>
                        {{ $t("cFueraDeMenus") }}
                    </th>
                    <th v-else @click="sortedArrayCantidadMenuDiferenciaDESC('cantidadDiferencia')" v-tooltip.top-center="'Cantidad fuera de menús'">
                      <i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("cFueraDeMenus") }}
                    </th>
                  </template>

                  <th
                    v-if="ordenarImporte === 0"
                    @click="sortedArrayImporteASC('importe')"
                  >
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("importe") }}
                  </th>
                  <th v-else @click="sortedArrayImporteDESC('importe')">
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("importe") }}
                  </th>
                  <th
                    v-if="ordenarPrecioMed === 0"
                    @click="sortedArrayPrecioMedASC('importe/cantidad')"
                  >
                    <i style="color: white" class="fa fa-angle-up"></i>
                    {{ $t("precioMed") }}
                  </th>
                  <th
                    v-else
                    @click="sortedArrayPrecioMedDESC('importe/cantidad')"
                  >
                    <i style="color: white" class="fa fa-angle-down"></i>
                    {{ $t("precioMed") }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="obj in list" :key="obj.id">
                  <td style="width:35%"><span style="color:#458195; cursor: pointer;" v-if="obj.menusPertenecientes.length > 0" @click="abrirModalDetallesMenu(obj)">⠀<i class="fas fa-list" style="font-weight: bold; font-size: 1.1em"></i>⠀{{obj.name}}</span><span v-else>{{obj.name}}</span> </td>
                  <td style="width:10%" class="text-right">
                    <span>{{ obj.barCode }}</span>
                  </td>
                  <td style="width:10%" class="text-right">
                    <span class="text-primary"
                      v-if="obj.pedirPeso">{{ obj.cantidad }} Kg.</span
                    >
                    <span v-else class="text-right">{{ obj.cantidad }}</span>
                  </td>

                  <template v-if="hayMenus">
                    <td style="width:10%" class="text-right">
                      <span class="text-primary"
                        v-if="obj.pedirPeso">{{ obj.cantidadMenu }} Kg.</span
                      >
                      <span v-else class="text-righ">{{obj.cantidadMenu}}</span>
                    </td>
                    <td style="width:15%" class="text-right">
                      <span class="text-primary"
                        v-if="obj.pedirPeso">{{ obj.cantidad - obj.cantidadMenu }} Kg.</span
                      >
                      <span v-else class="text-righ">{{obj.cantidad - obj.cantidadMenu}}</span>
                    </td>
                  </template>

                  <td class="text-right" style="width:15%">{{ obj.importe | currency }}</td>
                  <td class="text-right" style="width:15%">
                    {{ calcularMedia(obj) | currency }}
                  </td>
                </tr>
              </tbody>

              <tfoot>
                <tr class="table-success">
                  <td>
                    <strong>{{ $t("total") }}</strong>
                  </td>
                  <td></td>
                  <td class="text-right">
                    <strong>{{ getTotalUds }}</strong>
                    <i v-tooltip.top-center="$t('recuerdeQueLasLineasDeDescuentoNoSeSumanAlTotal')"
                      style="cursor: pointer;"
                      class="fa fa-info-circle">
                    </i>
                  </td>

                  <template v-if="hayMenus">
                    <td class="text-right">
                      <strong>{{ getTotalUdsMenus }}</strong>
                    </td>
                    <td class="text-right">
                      <strong>{{ getTotalUds - getTotalUdsMenus }}</strong>
                    </td>
                  </template>

                  <td class="text-right">
                    <strong>{{ getTotalPrecio | currency }}</strong>
                  </td>
                  <td></td>

                </tr>
              </tfoot>
            </table>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayVentasDeProductosEnEsteRangoDeFechas") }}
          </div>
        </template>
      </div>

      <div class="col-md-4 " v-show="this.list.length > 0 && respuesta && permiso">
        <div class="card">
          <button
            v
            v-if="chartIn === 0"
            @click="(chartIn = 1), initChart()"
            class="btn btn-primary col-md-12"
          >
            {{ $t("porUnidad") }}
          </button>
          <button
            v-else
            @click="(chartIn = 0), initChart()"
            class="btn btn-primary col-md-12"
          >
            {{ $t("porImporte") }}
          </button>

          <div
            class="chart-container col-md-12"
            style="height:300px; width: 100%"
          >
            <canvas id="chart"></canvas>
          </div>
        </div>
      </div>

      <modal
        name="detallesMenu"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div div>
          <div class="modal-header">
            <h5 style="margin: 0px">
              {{ $t("vecesQueSeHaVendidoDentroDeMenus") }}
            </h5>
          </div>
          <div class="modal-body">
            <div
                class="table-responsive"
                style="overflow: auto"
            >
              <table class="table table-bordered table-striped ">
                <thead class="thead-dark">
                    <tr>
                    <th style="width:90%">{{ $t("nombre") }} {{ $t("delMenu") }}</th>
                    <th>{{ $t("cantidad") }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(prod) in listaDetallesMenu" :key="prod.id + Math.random()">
                        <td>{{prod.name}}</td>
                        <td>{{prod.cantidad}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr></tr>
                </tfoot>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" @click="cerrarModalDetallesMenu()">
              <i class="fa fa-times-circle"></i>
              {{ $t("cerrar") }}
            </button>
          </div>
        </div>
      </modal>

    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Switch,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Loading,
  Checkbox,
  CheckboxGroup,
} from "element-ui";
import { mapState, mapMutations } from 'vuex';
import swal from "sweetalert2";
import moment from "moment";
//import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes.vue";
import bus from "../../../../bus";
import Vuex from "vuex";

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });;
    this.$store.dispatch("setNameRoute", this.$i18n.t("ventaDeProductosPorRangoDeMesas"));

    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    //CabeceraInformes,
    [DatePicker.name]: DatePicker,
    [Switch.name]: Switch,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  data() {
    return {
      loading: false,
      loadingConsulta: false,
      //idBusiness: 0,
      idBusiness: this.$route.params.idBusiness,
      listBusinesses: [],
      idTpv: 0,
      dateto: new Date().toISOString(),
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      list: [],
      mode: 0,
      $Chart: null,
      objectChart: null,
      contador: 0,
      chartIn: 0,
      listTpv: [],
      listIdTpv: [],
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },
      listCheckBoxTpv: [],
      idsTPV: [],
      respuesta: false,
      ordenacionProductos: 0,
      ordenarBarcode: 0,
      ordenarCantidad: 0,
      ordenarCantidadMenu: 0,
      ordenarCantidadMenuDiferencia: 0,
      ordenarImporte: 0,
      ordenarPrecioMed: 0,
      excluirMenu: false,
      checkValue:false,
      hayMenus: false,
      listaDetallesMenu: [],
      listRangoMesas: [],
      listIdRangomesas: [],
      idRangoMesa: 0,
    };
  },
  computed: {
    ...mapState(["permiso"]),
    urlExportPDF() {
      let idTpv = this.idTpv == -1 ? this.listIdTpv : [this.idTpv];

      let url = this.idRangoMesa == -1 ? this.$store.getters.apiUrl + "/products/exportVentasProduct/PDF?idBusiness=" + this.idBusiness + "&idTpv[]=" + idTpv + "&checkValue=" + 
        this.checkValue + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" +this.$store.getters.jwt 
        : 
        this.$store.getters.apiUrl + "/rangosMesas/exportVentasProductPorRangoMesa/PDF?idBusiness=" + this.idBusiness + "&idTpv[]=" + idTpv + "&checkValue=" + this.checkValue + 
        "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&idRangoMesa=" + this.idRangoMesa + "&jwt=" + 
        this.$store.getters.jwt;

      return (
        url
      );
    },

    urlExportExcel() {
      let idTpv = this.idTpv == -1 ? this.listIdTpv : [this.idTpv];

      let url = this.idRangoMesa == -1 ? this.$store.getters.apiUrl + "/products/exportVentasProduct/Excel?idBusiness=" + this.idBusiness + "&idTpv[]=" + idTpv + "&checkValue=" + 
        this.checkValue + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt
        :
        this.$store.getters.apiUrl + "/rangosMesas/exportVentasProductPorRangoMesa/Excel?idBusiness=" + this.idBusiness + "&idTpv[]=" + idTpv + "&checkValue=" + this.checkValue + 
        "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&idRangoMesa=" + this.idRangoMesa + "&jwt=" + 
        this.$store.getters.jwt;
      
      return (
        url
      );
    },

    getTotalPrecio() {
      let total = 0;

      this.list.forEach(function(d) {
        total += d.importe;
      });

      return total;
    },

    getTotalUds() {
      let total = 0;
      const patron = /.*Dto$/;

      this.list.forEach(function(d) {
        if (d.name != "Descuento" && !d.name.match(patron)) {
          total += d.cantidad;
        }
      });

      return total;
    },

    getTotalUdsMenus() {
      let total = 0;

      this.list.forEach(function(d) {
        if (d.name != "Descuento") {
          total += parseFloat(d.cantidadMenu);
        }
      });

      return total;
    },
  },
  methods: {
    abrirModalDetallesMenu(obj) {
      this.listaDetallesMenu = obj.menusPertenecientes;
      this.$modal.show('detallesMenu');
    },

    cerrarModalDetallesMenu() {
      this.$modal.hide('detallesMenu');
      this.listaDetallesMenu = [];
    },

    sortedArrayNameASC: function() {
      this.ordenacionProductos = 1;

      function compare(a, b) {
        if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
        if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayNameDESC: function() {
      this.ordenacionProductos = 0;

      function compare(a, b) {
        if (a.name.toUpperCase() > b.name.toUpperCase()) return -1;
        if (a.name.toUpperCase() < b.name.toUpperCase()) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayBarcodeASC: function() {
      this.ordenarBarcode = 1;

      function compare(a, b) {
        if (a.barCode < b.barCode) return -1;
        if (a.barCode > b.barCode) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    
    sortedArrayBarcodeDESC: function() {
      this.ordenarBarcode = 0;

      function compare(a, b) {
        if (a.barCode > b.barCode) return -1;
        if (a.barCode < b.barCode) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayCantidadASC: function() {
      this.ordenarCantidad = 1;

      function compare(a, b) {
        if (a.cantidad < b.cantidad) return -1;
        if (a.cantidad > b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayCantidadDESC: function() {
      this.ordenarCantidad = 0;

      function compare(a, b) {
        if (a.cantidad > b.cantidad) return -1;
        if (a.cantidad < b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayCantidadMenuASC: function() {
      this.ordenarCantidadMenu = 1;

      function compare(a, b) {
        if (a.cantidadMenu < b.cantidadMenu) return -1;
        if (a.cantidadMenu > b.cantidadMenu) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayCantidadMenuDESC: function() {
      this.ordenarCantidadMenu = 0;

      function compare(a, b) {
        if (a.cantidadMenu > b.cantidadMenu) return -1;
        if (a.cantidadMenu < b.cantidadMenu) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayCantidadMenuDiferenciaASC: function() {
      this.ordenarCantidadMenuDiferencia = 1;

      function compare(a, b) {
        if ((a.cantidad - a.cantidadMenu) < (b.cantidad - b.cantidadMenu)) return -1;
        if ((a.cantidad - a.cantidadMenu) > (b.cantidad - b.cantidadMenu)) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayCantidadMenuDiferenciaDESC: function() {
      this.ordenarCantidadMenuDiferencia = 0;

      function compare(a, b) {
        if ((a.cantidad - a.cantidadMenu) > (b.cantidad - b.cantidadMenu)) return -1;
        if ((a.cantidad - a.cantidadMenu) < (b.cantidad - b.cantidadMenu)) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayImporteASC: function() {
      this.ordenarImporte = 1;

      function compare(a, b) {
        if (a.importe < b.importe) return -1;
        if (a.importe > b.importe) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayImporteDESC: function() {
      this.ordenarImporte = 0;

      function compare(a, b) {
        if (a.importe > b.importe) return -1;
        if (a.importe < b.importe) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayPrecioMedASC: function() {
      this.ordenarPrecioMed = 1;

      function compare(a, b) {
        if (a.importe / a.cantidad < b.importe / b.cantidad) return -1;
        if (a.importe / a.cantidad > b.importe / b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayPrecioMedDESC: function() {
      this.ordenarPrecioMed = 0;

      function compare(a, b) {
        if (a.importe / a.cantidad > b.importe / b.cantidad) return -1;
        if (a.importe / a.cantidad < b.importe / b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    emitirConsulta() {
      if (this.idRangoMesa == -1) {
        this.getSalesProducts();
      } else {
        this.getSalesProductsByRangoMesa();
      }
    },

    changeTPV() {
      this.idsTPV = [];
      this.idsTPV.push(this.idTpv);

      this.getRangosDeMesas();
    },

    changeRango() {
      if (this.idRangoMesa === -1) {
        this.listIdRangomesas = [];

        for (let i = 0; i < this.listRangoMesas.length; i++) {
          this.listIdRangomesas.push(this.listRangoMesas[i].id);
        }

      } else {
        this.listIdRangomesas = [];
        this.listIdRangomesas.push(this.idRangoMesa);
      }

      this.emitirConsulta();
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.getTpv();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getTpv() {
      this.listTpv = [];
      this.listIdTpv = [];
      this.idsTPV = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.idsTPV = [];

            for (let i = 0; i < response.data.result.length; i++) {
              vm.idsTPV.push(response.data.result[i].id);
            }

            vm.listCheckBoxTpv = response.data.result;

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].nameShow,
                id: response.data.result[i].id,
              };

              vm.listTpv.push(printername);

              vm.listIdTpv.push(response.data.result[i].id);
            }
            vm.idTpv = vm.listTpv[0].id;

            vm.getRangosDeMesas();
          }

          vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getRangosDeMesas() {
      this.listRangoMesas = [];
      this.listIdRangomesas = [];
      this.idRangoMesa = -1;

      var config = {
        params: {
          idBusiness: this.idBusiness,
          idTpv: this.idTpv,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios.get(this.$store.getters.apiUrl + "rangosMesas/getRangosMesas", config)
        .then(function (response) {
          if (response.data.response) {

            let printer = {
              nameShow: vm.$t("todos"),
              id: -1,
            };
            vm.listRangoMesas.push(printer);

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].name + ' [' + response.data.result[i].initTable + ' - ' + response.data.result[i].endTable + ']',
                id: response.data.result[i].id,
              };

              vm.listRangoMesas.push(printername);
              vm.listIdRangomesas.push(response.data.result[i].id);
            }

            vm.respuesta = true;

            vm.getSalesProducts();
          } else {
            swal({
              title: vm.$t('atencion'),
              text: response.data.message,
              confirmButtonClass: 'btn btn-info btn-fill',
              type: 'error'
            });
            vm.respuesta = false;
          }
        })
        .catch(function (error) {
            console.log(error);
        });
    },

    getSalesProducts() {
      var ocultarProSaldo=0

      if(this.checkValue==true){
        ocultarProSaldo = 1
      }

      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });

        } else {
          this.loading = Loading.service({ text: "Cargando..." });;

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          let listaTPVs = this.idTpv == -1 ? this.listIdTpv : [this.idTpv];

          var config = {
            params: {
              idBusiness: this.idBusiness,
              ocultarProSaldo : ocultarProSaldo,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              idTpv: listaTPVs,
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;

          this.$store.dispatch("setIdBusiness", this.idBusiness);

          this.axios
            .get(
              this.$store.getters.apiUrl + "products/getSalesProducts",
              config
            )
            .then(function(response) {
              if (response.data.response) {
                vm.list = response.data.result;

                vm.hayMenus = vm.list.some(element => element.isMenu);

                vm.initChart();

                vm.respuesta = true;
                vm.loadingConsulta = false;

              } else if (response.data.response == false && response.data.rangoMayor == true) {
                swal({
                  title: "Lo sentimos",
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "info",
                });
                vm.respuesta = false;

              } else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: vm.$t("noTienesPermisoParaVisualizarEsteInforme"),
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }

              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },

    getSalesProductsByRangoMesa() {
      var ocultarProSaldo=0

      if(this.checkValue==true){
        ocultarProSaldo = 1
      }

      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();
      
        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        
        } else {
          this.loading = Loading.service({ text: "Cargando..." });;
        
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);
        
          let listaTPVs = this.idTpv == -1 ? this.listIdTpv : [this.idTpv];
        
          var config = {
            params: {
              idBusiness: this.idBusiness,
              ocultarProSaldo : ocultarProSaldo,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              idTpv: listaTPVs,
              idRangoMesa: this.idRangoMesa,
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };
        
          let vm = this;
        
          this.$store.dispatch("setIdBusiness", this.idBusiness);
        
          this.axios
            .get(
              this.$store.getters.apiUrl + "rangosMesas/getSalesProductsByRangoMesa",
              config
            )
            .then(function(response) {
              if (response.data.response) {
                vm.list = response.data.result;
              
                vm.hayMenus = vm.list.some(element => element.isMenu);
              
                vm.initChart();
              
                vm.respuesta = true;
                vm.loadingConsulta = false;
              
              } else if (response.data.response == false && response.data.rangoMayor == true) {
                swal({
                  title: "Lo sentimos",
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "info",
                });
                vm.respuesta = false;
              
              } else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: vm.$t("noTienesPermisoParaVisualizarEsteInforme"),
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              
                vm.respuesta = false;
              }
            
              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },

    calcularMedia(obj) {
      let media = 0;
      
      if (this.excluirMenu) {
        media =  obj.importe / (obj.cantidad - obj.cantidadMenu);
      } else {
        media = obj.importe / obj.cantidad;
      }

      return media;
    },

    initChart() {
      if (this.chartIn === 0) {
        var labels = this.list.map(function(x) {
          return x.name;
        });

        var data = this.list.map(function(x) {
          return x.cantidad;
        });

      } else {
        var labels = this.list.map(function(x) {
          return x.name;
        });

        var data = this.list.map(function(x) {
          return x.importe;
        });
      }

      var randomColor = require("randomcolor");

      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)"
        );
      });

      let borderColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)"
        );
      });

      let hoverBackgroundColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)"
        );
      });

      if (this.contador == 0) {
        if (this.list.length > 0) {
          this.objectChart = new Chart("chart", {
            type: "pie",
            data: {
              labels: labels,
              datasets: [
                {
                  data: data,
                  backgroundColor: backgroundColors,
                  borderColor: borderColors,
                  hoverBackgroundColor: hoverBackgroundColors,
                  borderWidth: 1,
                },
              ],
            },
            options: {
              legend: {
                display: false,
                position: "bottom",
              },
              maintainAspectRatio: false,
            },
          });

          this.contador++;
        }

      } else {
        this.objectChart.destroy();

        this.objectChart = new Chart("chart", {
          type: "pie",
          data: {
            labels: labels,
            datasets: [
              {
                data: data,
                backgroundColor: backgroundColors,
                borderColor: borderColors,
                hoverBackgroundColor: hoverBackgroundColors,
                borderWidth: 1,
              },
            ],
          },
          options: {
            legend: {
              display: false,
              position: "bottom",
            },
            maintainAspectRatio: false,
          },
        });
      }
    },
  },
};
</script>
<style scoped>
a li {
  color: #111;
}
.card {
  padding: 20px;
}
.div-export {
  margin-bottom: 10px;
}
body {
  background: #1d1f20;
  padding: 16px;
}
.chart-container {
  position: relative;
  margin: auto;
  height: 80vh;
  width: 80vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Productos/VentasProductosPorRangoDeMesas.vue